export const toRoles = roles =>
  roles.map(role => ({
    value: role.name,
    label: role.value
  }))
